module.exports = __webpack_public_path__ + "static/media/f8.aeed856b.png";